import { ProductVariant } from "@/lib/centra/localAtomics";
import { useTranslations } from "next-intl";
import { Sizes } from "./ActionSection";

interface IUseProductButtonLabelProps {
  sizes: Sizes;
  product?: ProductVariant;
}

export const useProductButtonLabel = ({
  sizes,
  product,
}: IUseProductButtonLabelProps) => {
  const t = useTranslations();
  /* notify logic */
  if (!!product?.comingSoon) {
    return {
      label: t("product.button.comingSoon"),
      disabled: false,
      comingSoon: true,
    };
  }

  if (!sizes?.selectedSize)
    return {
      label: t("product.button.selectSize"),
      disabled: true,
    };

  if (
    (sizes.selectedSize && sizes.selectedSize.stock === false) ||
    (sizes.sizes && sizes.sizes.every((size) => size.stock === false))
  ) {
    return {
      label: t("product.button.notifyWhenAvailable"),
      disabled: false,
      notifyBackInStock: true,
    };
  }

  if (
    sizes.sizes &&
    sizes.sizes.length > 1 &&
    sizes.sizes.filter((size) => size.stock === true).length === 0
  )
    return {
      label: t("product.button.outOfStock"),
      disabled: true,
    };

  if (sizes?.selectedSize?.fewLeft)
    return {
      label: t("product.button.onlyFewLeft"),
      disabled: false,
    };

  if (
    sizes.sizes &&
    sizes.sizes.length === 1 &&
    sizes.sizes[0].stock === true
  ) {
    return {
      label: t("product.button.addToCart"),
      disabled: false,
    };
  }
  return {
    label: t("product.button.addToCart"),
    disabled: false,
  };
};
